/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {UserInformationContract} from '../../../api/ms-security/contracts/user-information.contract';
import {UserInformationModel} from './user-information.model';
import {AuthorizationContextPermissionsMapper} from './authorization-context-permissions.mapper';

export class UserInformationMapper {

    private constructor() {
    }

    static fromUserInformationContract(input: UserInformationContract): UserInformationModel {
        let model: UserInformationModel;

        if (input != null) {
            model = {
                username: input.username,
                permissions: AuthorizationContextPermissionsMapper.toContextPermissionsMap(
                        input.authorizationContextPermissions),
                multiPartner: input.multiPartner,
                multiSupplyingPackingPlant: input.multiSupplyingPackingPlant,
                multiTechnician: input.multiTechnician,
                multiSupplier: input.multiSupplier
            };
        }
        return model;
    }
}
